import React from 'react';
import PolicyPage from '../../components/PolicyPage';

const FeesPolicy: React.FC = () => (
  <PolicyPage slug="fees-policy" subtitle="Fees Policy" />
);

export default FeesPolicy;
